module.exports = __webpack_public_path__ + "img/19.7793a974.png";